import { Component, Input } from '@angular/core';
import { DEFAULT_DATE_TIME_SECONDS_FORMAT } from 'src/app/core/ccomx-date-formats';

@Component({
  selector: 'app-export-errors-template',
  templateUrl: './export-errors-template.component.html',
  styleUrls: ['./export-errors-template.component.scss'],
  standalone: false,
})
export class ExportErrorsTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;

  dateTimeFormat = DEFAULT_DATE_TIME_SECONDS_FORMAT;
}
